import React, { useState } from 'react';

const Tenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: Elevated Zen */
            --primary: #588157;
            /* Richer Sage */
            --primary-dark: #3a5a40;
            --primary-light: #a3b18a;
            --accent: #bc6c25;
            /* Warm Earth/Amber */
            --bg-body: #fefae0;
            /* Soft Buttercream/Light Sand */
            --bg-white: #ffffff;
            --text-dark: #283618;
            /* Deep Green-Black */
            --text-muted: #606c38;

            --font-head: 'Cormorant Garamond', serif;
            --font-body: 'Quicksand', sans-serif;

            --radius-soft: 24px;
            --shadow-float: 0 15px 40px rgba(58, 90, 64, 0.15);
            --gradient-primary: linear-gradient(135deg, #588157 0%, #3a5a40 100%);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--bg-body);
            line-height: 1.8;
            overflow-x: hidden;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            font-family: var(--font-head);
            color: var(--text-dark);
            line-height: 1.1;
            font-weight: 700;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.4s ease;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            position: relative;
            z-index: 2;
        }

        .section {
            padding: 120px 0;
            position: relative;
        }

        /* Organic Waves */
        .wave-divider {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            overflow: hidden;
            line-height: 0;
            transform: rotate(180deg);
        }

        .wave-divider svg {
            position: relative;
            display: block;
            width: calc(100% + 1.3px);
            height: 100px;
        }

        .wave-divider .shape-fill {
            fill: var(--bg-body);
        }

        .wave-top {
            top: 0;
            bottom: auto;
            transform: none;
        }


        /* Buttons */
        .btn {
            display: inline-block;
            padding: 15px 40px;
            background-color: var(--primary);
            color: var(--white);
            border-radius: 50px;
            font-weight: 600;
            letter-spacing: 1px;
            border: 1px solid transparent;
            box-shadow: 0 4px 15px rgba(132, 169, 140, 0.3);
            cursor: pointer;
        }

        .btn:hover {
            background-color: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(132, 169, 140, 0.4);
        }

        .btn-outline {
            background-color: transparent;
            color: var(--text-dark);
            border: 1px solid var(--text-dark);
        }

        .btn-outline:hover {
            background-color: var(--text-dark);
            color: var(--white);
        }

        /* Top Bar */
        .top-bar {
            background-color: var(--bg-section);
            padding: 12px 0;
            font-size: 0.95rem;
            color: var(--text-muted);
            border-bottom: 1px solid rgba(0, 0, 0, 0.03);
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .contact-info {
            display: flex;
            gap: 30px;
        }

        .contact-info span {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .contact-info i {
            color: var(--primary);
        }

        /* Nav */
        .navbar {
            padding: 25px 0;
            background: rgba(253, 252, 248, 0.95);
            backdrop-filter: blur(8px);
            position: sticky;
            top: 0;
            z-index: 1000;
            box-shadow: 0 2px 20px rgba(0, 0, 0, 0.02);
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-family: var(--font-head);
            font-size: 2.2rem;
            font-weight: 700;
            color: var(--primary-dark);
        }

        .brand span {
            color: var(--accent);
            font-style: italic;
        }

        .nav-menu {
            display: flex;
            gap: 40px;
            list-style: none;
        }

        .nav-menu a {
            font-weight: 500;
            color: var(--text-muted);
            font-size: 1.05rem;
        }

        .nav-menu a:hover {
            color: var(--primary);
        }

        /* Hero */
        .hero {
            height: 85vh;
            min-height: 600px;
            background: url('https://images.unsplash.com/photo-1545205597-3d9d02c29597?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') center/cover;
            display: flex;
            align-items: center;
            position: relative;
        }

        .hero-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(to right, rgba(253, 252, 248, 0.8), rgba(253, 252, 248, 0.3));
        }

        .hero-content {
            position: relative;
            max-width: 600px;
            z-index: 1;
        }

        .hero-label {
            display: block;
            color: var(--primary-dark);
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 15px;
            font-weight: 700;
            font-size: 0.9rem;
        }

        .hero h1 {
            font-size: 4.5rem;
            margin-bottom: 25px;
            color: var(--text-dark);
            font-style: italic;
        }

        .hero p {
            font-size: 1.2rem;
            color: var(--text-muted);
            margin-bottom: 40px;
            line-height: 1.6;
        }

        /* About */
        .section-header {
            text-align: center;
            max-width: 700px;
            margin: 0 auto 60px;
        }

        .section-header span {
            color: var(--accent);
            font-family: var(--font-body);
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 0.9rem;
            font-weight: 600;
            display: block;
            margin-bottom: 15px;
        }

        .section-header h2 {
            font-size: 3rem;
            color: var(--primary-dark);
            margin-bottom: 20px;
        }

        .about-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
        }

        .about-img {
            border-radius: 200px 200px 20px 20px;
            overflow: hidden;
            height: 500px;
            position: relative;
        }

        .about-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .feature-box {
            background: var(--white);
            padding: 30px;
            border-radius: var(--radius-soft);
            box-shadow: var(--shadow-float);
            margin-top: 30px;
            border-left: 4px solid var(--primary);
        }

        /* Classes */
        .class-section {
            background-color: var(--bg-section);
        }

        .class-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .class-card {
            background: var(--white);
            border-radius: var(--radius-soft);
            overflow: hidden;
            transition: 0.4s;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .class-card:hover {
            transform: translateY(-10px);
            box-shadow: var(--shadow-float);
        }

        .class-img {
            height: 250px;
            overflow: hidden;
        }

        .class-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
        }

        .class-card:hover .class-img img {
            transform: scale(1.05);
        }

        .class-content {
            padding: 30px;
            text-align: center;
        }

        .class-content h3 {
            font-size: 1.8rem;
            margin-bottom: 10px;
            color: var(--primary-dark);
        }

        .class-content p {
            color: var(--text-muted);
            margin-bottom: 20px;
            font-size: 0.95rem;
        }

        .class-meta {
            display: flex;
            justify-content: center;
            gap: 15px;
            font-size: 0.9rem;
            color: var(--accent);
            font-weight: 600;
            margin-bottom: 20px;
        }

        /* Gallery */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 15px;
        }

        .gallery-item {
            height: 300px;
            border-radius: 12px;
            overflow: hidden;
            position: relative;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.6s;
            filter: grayscale(20%);
        }

        .gallery-item:hover img {
            transform: scale(1.1);
            filter: grayscale(0%);
        }

        .gallery-item:nth-child(2) {
            grid-column: span 2;
        }

        /* Testimonials */
        .review-section {
            text-align: center;
            background: url('https://www.transparenttextures.com/patterns/cubes.png');
        }

        .review-slider {
            display: flex;
            overflow-x: auto;
            gap: 40px;
            padding: 20px 0 40px;
            scrollbar-width: none;
        }

        .review-card {
            min-width: 400px;
            background: var(--white);
            padding: 40px;
            border-radius: var(--radius-soft);
            box-shadow: var(--shadow-float);
            position: relative;
        }

        .quote-icon {
            font-size: 4rem;
            color: var(--bg-section);
            font-family: serif;
            position: absolute;
            top: 20px;
            left: 20px;
            line-height: 1;
        }

        .review-text {
            font-family: var(--font-head);
            font-size: 1.4rem;
            font-style: italic;
            margin-bottom: 20px;
            position: relative;
            z-index: 1;
            color: var(--text-dark);
        }

        .reviewer {
            font-weight: 600;
            color: var(--primary-dark);
            text-transform: uppercase;
            letter-spacing: 1px;
            font-size: 0.9rem;
        }

        /* Footer */
        footer {
            background-color: var(--primary-dark);
            color: #d8e2dc;
            padding: 80px 0 30px;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1fr;
            gap: 40px;
            margin-bottom: 60px;
        }

        .footer-brand {
            font-family: var(--font-head);
            font-size: 2rem;
            color: var(--white);
            margin-bottom: 20px;
            display: block;
        }

        .footer-links h4 {
            color: var(--white);
            margin-bottom: 25px;
            font-family: var(--font-body);
        }

        .footer-links ul {
            list-style: none;
        }

        .footer-links li {
            margin-bottom: 12px;
        }

        .footer-links a:hover {
            color: var(--white);
        }

        .socials {
            display: flex;
            gap: 15px;
            margin-top: 25px;
        }

        .socials a {
            width: 40px;
            height: 40px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .socials a:hover {
            background: var(--white);
            color: var(--primary-dark);
        }

        .copyright {
            text-align: center;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            padding-top: 30px;
            font-size: 0.9rem;
        }

        /* Mobile */
        @media (max-width: 900px) {
            .hero h1 {
                font-size: 3rem;
            }

            .about-grid {
                grid-template-columns: 1fr;
            }

            .class-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .gallery-item:nth-child(2) {
                grid-column: span 1;
            }

            .footer-grid {
                grid-template-columns: 1fr;
            }

            .top-bar {
                display: none;
            }

            .nav-menu {
                display: none;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,400&family=Quicksand:wght@300;400;500;600&display=swap"
                rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="contact-info">
                        {get_data.business_location_name && <span><i>📍</i> {get_data.business_location_name}</span>}
                        {get_data.email && <span><i>✉️</i> {get_data.email}</span>}
                        {get_data.mobile && <span><i>📞</i> {get_data.mobile}</span>}
                    </div>
                    <div>
                        <span>Open Daily: 9:00 AM - 9:00 PM</span>
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <ul className="nav-menu">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#reviews">Testimonials</a></li>
                    </ul>
                    <a href="#contact" className="btn">Contact Us</a>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="hero-content">
                        <span className="hero-label">Welcome to your sanctuary</span>
                        <h1>Harmony In<br />Every Breath.</h1>
                        <p>Reconnect with your inner self through the ancient practice of yoga. Find balance, strength, and
                            tranquility in our peaceful studio.</p>
                        <div style={{display: 'flex', gap: '20px'}}>
                            <a href="#classes" className="btn">Start Your Journey</a>
                            <a href="#about" className="btn btn-outline">Learn More</a>
                        </div>
                    </div>
                </div>
                {/* Wave Divider Bottom */}
                <div className="wave-divider">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                        preserveAspectRatio="none">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                            className="shape-fill"></path>
                    </svg>
                </div>
            </header>

            {/* About */}
            <section className="section" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div className="about-img">
                            <img src="https://images.unsplash.com/photo-1545205597-3d9d02c29597?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                alt="Yoga Pose" />
                        </div>
                        <div className="about-text">
                            <div className="section-header" style={{textAlign: 'left', margin: '0 0 30px'}}>
                                <span>Our Philosophy</span>
                                <h2>Mindful Movement,<br />Rooted in Tradition.</h2>
                            </div>
                            <p style={{marginBottom: '20px', color: 'var(--text-muted)'}}>At Serenity Flow, we believe yoga is more
                                than just physical exercise; it is a pathway to the self. Our studio is designed as a sanctuary
                                away from the chaos of modern life, where you can breathe, move, and simply be.</p>
                            <p style={{color: 'var(--text-muted)'}}>Guided by experienced instructors, our classes cater to all
                                levels, honoring the unique journey of every individual.</p>

                            <div className="feature-box">
                                <h4 style={{color: 'var(--primary-dark)', marginBottom: '10px'}}>Holistic Wellness</h4>
                                <p style={{fontSize: '0.95rem', color: 'var(--text-muted)'}}>Integrating breathwork, meditation, and
                                    movement to heal the mind, body, and spirit.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="section class-section" id="services" style={{backgroundColor: '#e9edc9', position: 'relative'}}>
                {/* Top Wave */}
                <div className="wave-divider wave-top">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                        preserveAspectRatio="none">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                            className="shape-fill"></path>
                    </svg>
                </div>
                <div className="container">
                    <div className="section-header">
                        <span>Our Offerings</span>
                        <h2>Services</h2>
                    </div>

                    <div className="class-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="class-card" key={index}>
                                <div className="class-img" style={{height: '250px', overflow: 'hidden'}}>
                                    {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                            alt={item.name}
                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                        />
                                    ) : (
                                        <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0'}}>
                                            <span style={{fontSize: '3rem'}}>✨</span>
                                        </div>
                                    )}
                                </div>
                                <div className="class-content">
                                    <h3>{item.name}</h3>
                                    <p>{item.description || 'Service description pending.'}</p>
                                    <div style={{display: 'flex', justifyContent: 'center', gap: '10px'}}>
                                        <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{padding: '10px 20px', fontSize: '0.9rem'}}>Call</a>
                                        <a href="#contact" className="btn" style={{padding: '10px 20px', fontSize: '0.9rem'}}>Enquiry</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products Section */}
            <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <span>Our Collection</span>
                        <h2>Products</h2>
                    </div>

                    <div className="gallery-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="gallery-item" key={index} style={{height: 'auto', background: 'var(--white)', borderRadius: '12px', boxShadow: 'var(--shadow-float)', overflow: 'hidden'}}>
                                <div style={{height: '200px', overflow: 'hidden'}}>
                                     <img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                    />
                                </div>
                                <div style={{padding: '20px'}}>
                                    <h3 style={{fontSize: '1.2rem', marginBottom: '10px', color: 'var(--primary-dark)'}}>{item.service_name}</h3>
                                    {item.price && <p style={{color: 'var(--accent)', fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '10px'}}>₹{item.price}</p>}
                                    <p style={{fontSize: '0.9rem', color: 'var(--text-muted)', marginBottom: '15px'}}>{item.description || 'Quality product.'}</p>
                                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                        <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', padding: '10px', fontSize: '0.9rem', textAlign: 'center'}}>Order Now</button>
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{flex: 1, padding: '8px', fontSize: '0.8rem', textAlign: 'center'}}>Call</a>
                                            <a href="#contact" className="btn btn-outline" style={{flex: 1, padding: '8px', fontSize: '0.8rem', textAlign: 'center'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="section review-section" id="reviews"
                style={{background: 'linear-gradient(to bottom, #fefae0, #e9edc9)', position: 'relative'}}>
                <div className="wave-divider wave-top">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                        preserveAspectRatio="none">
                        <path
                            d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                            className="shape-fill"></path>
                    </svg>
                </div>
                <div className="container">
                    <div className="section-header">
                        <span>Community Love</span>
                        <h2>Stories of Transformation</h2>
                    </div>

                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="review-slider">
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                    <div className="quote-icon">“</div>
                                    <div style={{marginBottom: '15px', color: 'var(--accent)'}}>
                                        {review.rating && <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>}
                                    </div>
                                    <p className="review-text">"{review.review || 'No review data.'}"</p>
                                    <div className="reviewer">- {review.user_name || 'Valued Member'}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-muted)'}}>
                            <p>No reviews yet.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact" style={{position: 'relative', paddingTop: '150px'}}>
                <div className="wave-divider wave-top">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                        preserveAspectRatio="none">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                            className="shape-fill" fill="#e9edc9"></path>
                    </svg>
                </div>
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-about">
                            <a href="#" className="footer-brand">{get_data.service_name}</a>
                            <p style={{marginTop: '20px', lineHeight: '1.6'}}>Dedicated to providing quality services and
                                products. Join our community today.</p>
                            <div className="socials">
                                {get_data.instagram && <a href={get_data.instagram}>ig</a>}
                                {get_data.facebook && <a href={get_data.facebook}>fb</a>}
                                {get_data.youtube && <a href={get_data.youtube}>yt</a>}
                                {get_data.twitter && <a href={get_data.twitter}>tw</a>}
                            </div>
                        </div>

                        <div className="footer-links">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><a href="#">About Us</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                                <li><a href="#reviews">Testimonials</a></li>
                            </ul>
                        </div>

                        <div className="footer-links">
                            <h4>Services</h4>
                            <ul>
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Our Products</a></li>
                            </ul>
                        </div>

                        <div className="footer-links">
                            <h4>Visit Us</h4>
                            <ul>
                                <li>{get_data.business_location_name}</li>
                                <li>{get_data.mobile}</li>
                                <li>{get_data.email}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="copyright">
                        &copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Company'}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Tenththeme
